import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';


UIkit.icon.add({
	newline: `
		<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
			<polyline fill="none" stroke="#000" points="10 14 5 9.5 10 5" />
			<line fill="none" stroke="#000" x1="16" y1="9.5" x2="5" y2="9.52" />
			<line fill="none" stroke="#000" x1="15.61" y1="10" x2="15.59" y2="4" />
		</svg>
	`,
	euro: `
		<svg width="20" height="20" viewBox="0 0 20 20">
			<path
				d="m 16.733414,17.816691 c -0.05866,-0.295983 -0.349776,-0.485358 -0.643928,-0.418259 -0.477322,0.108884 -1.228361,0.323364 -2.027947,0.241651 C 11.551621,17.383587 8.4667598,14.78834 7.5947954,12.526777 h 5.1640266 c 0.250612,0 0.458634,-0.175968 0.522679,-0.418259 l 0.195885,-0.74106 c 0.07527,-0.334911 -0.17942,-0.65317 -0.522679,-0.65317 H 6.9619827 C 6.9079647,10.074645 6.9810677,9.4514749 7.0503087,8.8283499 H 13.59464 c 0.251735,1.2e-5 0.38731,-0.175248 0.441139,-0.42116 l 0.290714,-0.8838051 c 0.07313,-0.334107 -0.181295,-0.6500849 -0.523348,-0.650267 l -6.1731264,-0.0033 c 0.9211162,-2.008527 3.8685044,-4.41549 6.2952264,-4.6786709 0.642926,-0.06973 1.061456,-0.0051 1.689777,0.185044 0.2775,0.05661 0.551205,-0.111517 0.625089,-0.3849551 l 0.535312,-1.09284695 c 0.08134,-0.300937 -0.110044,-0.607857 -0.416339,-0.665937 -0.540357,-0.102455 -1.411205,-0.232455 -2.352054,-0.232455 -4.338572,0 -7.8395097,3.13436505 -9.1321437,6.87311595 H 3.3983237 c -0.2958482,5e-6 -0.5357143,0.239871 -0.5357143,0.535719 v 0.8838041 c 0,0.2958479 0.2398661,0.535714 0.5357143,0.535714 h 0.9629019 c -0.045045,0.607456 -0.052723,1.3074561 -0.00808,1.8859381 H 3.3983237 c -0.2958482,0 -0.5357143,0.239866 -0.5357143,0.535714 v 0.741061 c 0,0.295848 0.2398661,0.535714 0.5357143,0.535714 h 1.3443751 c 1.1171876,4.032679 4.604911,7.473226 9.2643312,7.473226 1.174152,0 2.167947,-0.202857 2.727724,-0.347679 0.275312,-0.07121 0.447634,-0.344107 0.392321,-0.62308 z"
				fill="currentColor" />
		</svg>
	`,
	percentage: `
		<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
			<circle fill="none" stroke="currentColor" cx="4" cy="3.5" r="2.5"></circle>
			<circle fill="none" stroke="currentColor" cx="16" cy="16.5" r="2.5"></circle>
			<line fill="none" stroke="currentColor" stroke-width="1.1" x1="16" y1="3.5" x2="4" y2="16.5"></line>
		</svg>
	`,
	'chevron-double-up': `
		<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" data-svg="chevron-double-up">
			<polyline fill="none" stroke="#000" stroke-width="1.03" points="4 10 10 4 16 10"></polyline>
			<polyline fill="none" stroke="#000" stroke-width="1.03" points="4 16 10 10 16 16"></polyline>
		</svg>
	`,
	'chevron-double-down': `
	<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" data-svg="chevron-double-down">
		<polyline fill="none" stroke="#000" stroke-width="1.03" points="16 4 10 10 4 4"></polyline>
		<polyline fill="none" stroke="#000" stroke-width="1.03" points="16 10 10 16 4 10"></polyline>
	</svg>
	`,
});
UIkit.use(Icons);